<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mLIbZA/image/Front.jpg?1726850954111" alt="This image is the cover for the book A Boy Named Tāne"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Boy Named Tāne
      </h1>
      <p class="bookDescription body article font2">
        <p>Tāne is a young boy who feels very different to other children. He is an only child, of indigenous Māori and European descent, who lives with his mother in Aotearoa (New Zealand). They live a life that is distinct but not entirely separate from mainstream living. Tāne loves the forest and being away from the hustle and bustle of city life. The more time Tāne spends in the forest, the more he starts to connect with himself and with his natural environment. Join Tāne on his adventures in Waipoua Forest and find out what happens to him as he grows closer to nature and to his own being.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anna McVeigh, Tukara Matthews
      </h2>
      
      <p class="authorDescription body article">Anna McVeigh was born and raised in Aotearoa, also known as New Zealand. Having previously worked as a language teacher and tour guide, Anna fell in love with language and aspects of cultural identity. On her explorations throughout Aotearoa, she was inspired by the natural beauty of the country and with Te ao Māori (the Māori world). Over time, Anna has developed a deep interest in Māori history and culture and in particular the proverbs, myths and legends that speak to the heart of human nature and connection. Anna now works from her home as a narrative and somatic therapist, a writer and a musician. She is learning te reo Māori (the Māori language) with her son, Felix Tāne, who is of Māori and European descent. This book was written with her son in mind and because Anna’s true passion lies in personal development and fostering connection. She believes that nurturing peace, presence and joy, along with deep and intimate connections with ourselves, others and the world around us is what makes life beautiful and meaningful. Anna adores working with children and adults, helping them feel more grounded in who they are, where they come from and where they are going.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7bbef9c4